import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=75bbdff9&"
import script from "./Footer.vue?vue&type=script&lang=ts&"
export * from "./Footer.vue?vue&type=script&lang=ts&"
import style0 from "./Footer.vue?vue&type=style&index=0&id=75bbdff9&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75bbdff9')) {
      api.createRecord('75bbdff9', component.options)
    } else {
      api.reload('75bbdff9', component.options)
    }
    module.hot.accept("./Footer.vue?vue&type=template&id=75bbdff9&", function () {
      api.rerender('75bbdff9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/layout/thirdparty/Footer.vue"
export default component.exports